enum ArithmeticOperation {
  ADD = 'ADD',
  SUBTRACT = 'SUBTRACT',
  MULTIPLY = 'MULTIPLY',
  DIVIDE = 'DIVIDE'
}

export const ArithmeticOperationLabels: Record<ArithmeticOperation, string> = {
  [ArithmeticOperation.ADD]: '+',
  [ArithmeticOperation.SUBTRACT]: '-',
  [ArithmeticOperation.MULTIPLY]: '×',
  [ArithmeticOperation.DIVIDE]: '÷'
};

export default ArithmeticOperation;
